import { Modal as AntModal } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'

const Modal = ({
  open,
  onCancel,
  children,
  title,
  width,
  bodyStyle,
  style,
  maxHeight,
  centered = true,
  ...props
}) => {
  return (
    <AntModal
      title={title}
      open={open}
      onCancel={onCancel}
      width={width || 474}
      bodyStyle={{
        overflowY: 'scroll',
        minHeight: 150,
        maxHeight: maxHeight || 580,
        padding: '0 16px 0 24px',
        ...bodyStyle,
      }}
      footer={false}
      centered={centered}
      style={{ ...style }}
      {...props}
      className="modal-component"
    >
      {children}
    </AntModal>
  )
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  centered: PropTypes.bool,
  onCancel: PropTypes.func,
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  width: PropTypes.number,
  bodyStyle: PropTypes.object,
  style: PropTypes.object,
  maxHeight: PropTypes.number,
}

Modal.defaultProps = {
  width: 474,
  maxHeight: 580,
}

export default Modal
